<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="private-offers">
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="unlockPrivateOffersEnabled">Unlock Private Offers
          <i class="pi pi-info-circle"
             pTooltip="Enable account-level private offers (Unlock/Reveal). Defaults OFF."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <p-inputSwitch
          id="unlockPrivateOffersEnabled"
          formControlName="unlockPrivateOffersEnabled">
        </p-inputSwitch>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="includePrivateOffersInExternalAdvertising">Include Private Offers in External Advertising</label>
      </div>
      <div class="field-switch-label">
        <p-inputSwitch
          id="includePrivateOffersInExternalAdvertising"
          formControlName="includePrivateOffersInExternalAdvertising">
        </p-inputSwitch>
      </div>
    </div>
  </div>
</form>
